import React from 'react'
// context
import { KPIContext } from 'context/index'
// constants
import { ENTITIES } from 'constants/index'
// view components
import ReviewsListContainer from 'containers/Review/ReviewList'

const KPIReviewsList: React.FC = () => {
  const { entity } = React.useContext(KPIContext) as any

  const {
    kpiCreateScheduledReview,
    kpiDeleteScheduledReview,
    kpiModifyScheduledReview,
    kpiViewCompletedReview,
    kpiViewInProgressReview
  } = entity.currentPermissions

  return (
    <ReviewsListContainer
      canCreate={kpiCreateScheduledReview}
      canDelete={kpiDeleteScheduledReview}
      canModify={kpiModifyScheduledReview}
      canViewCompleted={kpiViewCompletedReview}
      canViewInProgress={kpiViewInProgressReview}
      entity={{ ...entity, entityType: ENTITIES.PLAN_KPI }}
    />
  )
}

export default KPIReviewsList
